import { useMutation } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';

/**
 * Thread-open refresh: pulls the thread's invoice AND the Famous receipts that
 * touched it, then re-derives the thread's state (title regeneration, and
 * auto-resolution when the invoice comes back paid in full).
 *
 * Intentionally silent — no toast. The caller decides which queries to
 * invalidate from the returned counts, so a refresh that changed nothing
 * doesn't churn the view the user is reading.
 */
export function useRefreshArCollectionThreadFromFamous() {
  return useMutation(
    orpc.accountsReceivable.arCollectionThreads.refreshFromFamous.mutationOptions(),
  );
}
